import { Link } from 'react-router';
import { Checkbox } from '@/components/ui';
import { COMMON_CONSENT_CODES, COMMON_CONSENT_LABELS, type CommonConsentCode } from '../commonConsents';

/**
 * QA-507 — 상품 공통 동의 4종 사용 여부(고도몰 상품 [이벤트 수집 항목 → 개별동의] 사용함/사용안함). 문구는 [동의 문구 관리]에서
 * 몰별로 관리하고, 여기서는 이 상품에 붙일지만 고른다. 고른 동의는 4개 몰 모두에 그 몰 문구로 나간다.
 */
export const ProductCommonConsentsField = ({
  value,
  disabled,
  onChange,
}: {
  value: ReadonlyArray<CommonConsentCode>;
  disabled?: boolean;
  onChange: (next: CommonConsentCode[]) => void;
}) => {
  const toggle = (code: CommonConsentCode, on: boolean) => {
    const set = new Set(value);
    if (on) set.add(code);
    else set.delete(code);
    onChange(COMMON_CONSENT_CODES.filter((c) => set.has(c)));
  };
  return (
    <div className="mb-5 flex flex-col gap-2 rounded-md px-3 py-3" style={{ background: 'var(--surface-1)' }} data-testid="product-common-consents">
      <span className="text-[13px] font-medium" style={{ color: 'var(--content-strong)' }}>
        공통 동의
      </span>
      <div className="flex flex-wrap gap-x-5 gap-y-2">
        {COMMON_CONSENT_CODES.map((code) => (
          <label key={code} className="inline-flex cursor-pointer items-center gap-2 text-[13px]" style={{ color: 'var(--content-default)' }}>
            <Checkbox
              checked={value.includes(code)}
              disabled={disabled}
              onCheckedChange={(v) => toggle(code, v === true)}
              aria-label={COMMON_CONSENT_LABELS[code]}
              data-testid={`product-common-consent-${code}`}
            />
            {COMMON_CONSENT_LABELS[code]}
          </label>
        ))}
      </div>
      <p className="text-[12px]" style={{ color: 'var(--content-muted)' }}>
        체크한 동의만 쇼핑몰 상세·주문서에 나옵니다(4개 몰 모두, 각 몰 문구로). 문구는{' '}
        <Link to="/products/consent-templates" className="underline" target="_blank" rel="noopener noreferrer">
          동의 문구 관리
        </Link>
        에서 고칩니다. 같은 내용을 아래 개별 동의로 또 넣으면 쇼핑몰에 두 번 보입니다.
      </p>
    </div>
  );
};
